import React, { useState, useRef, Fragment, useEffect } from 'react';
import { Button, Tooltip } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { DownloadIcon } from '../../../../config/svg/CommonSvg';
import { FeedbackDetailPdf } from '../FeedbackDetailPdf';
import { getFeedbackDetailsPdf } from '../../../../action/performanceImprovementPlan';
import { OKRButton } from '../../../Common/OKRButton';

export default function FeedbackDownloadPdf(props) {
	const { feedbackId, setLoader } = props;
	const { enqueueSnackbar } = useSnackbar();
	const { t } = useTranslation();
	const textInput = useRef();
	const dispatch = useDispatch();

	const [pdfDetail, setPdfDetail] = useState(null);

	useEffect(() => {
		if (pdfDetail) {
			setTimeout(() => {
				if (textInput.current) textInput.current.click();
				setLoader(false);
			}, 1000);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pdfDetail]);

	const onError = (data) => {
		setLoader(false);
		setPdfDetail(null);
		const apiMessage = data?.messageList && Object.values(data.messageList)[0];
		enqueueSnackbar(apiMessage || 'Error occurred while downloading Feedback', {
			variant: 'error',
			autoHideDuration: 3000,
		});
	};

	const downloadPdf = async () => {
		setLoader(true);
		try {
			const res = await dispatch(getFeedbackDetailsPdf(feedbackId));
			if (res?.data?.status === 200) {
				setPdfDetail(res.data.entity);
			} else {
				onError(res?.data || res?.response?.data);
			}
		} catch (error) {
			onError(error?.response?.data);
		}
	};

	return (
		<Fragment>
			<OKRButton
				className='btn-link-type1 font-weight-bold'
				icon={<DownloadIcon />}
				text={t('download')}
				handleClick={downloadPdf}
			/>
			{pdfDetail && (
				<PDFDownloadLink
					document={<FeedbackDetailPdf data={pdfDetail} />}
					fileName={`Feedback_${pdfDetail?.nomineeDetails?.firstName || ''}_${pdfDetail?.nomineeDetails?.lastName || ''}.pdf`}
					style={{ display: 'none' }}
				>
					<Tooltip title={t('download')} arrow>
						<Button className='download-btn' ref={textInput}>
							<DownloadIcon />
						</Button>
					</Tooltip>
				</PDFDownloadLink>
			)}
		</Fragment>
	);
}
